import React from 'react';
import styled from 'styled-components';
import { IconProps } from './types';

const TruckIcon = (props: IconProps): JSX.Element => (
  // allow prop spreading for svg icon
  // eslint-disable-next-line
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M14 .75v3h2.978a1.5 1.5 0 0 1 1.22.628L21.5 9v3.75a1.5 1.5 0 0 1-1.5 1.5h-.888c.084.236.138.485.138.75a2.25 2.25 0 1 1-4.5 0c0-.265.054-.514.138-.75H7.862c.084.236.138.485.138.75a2.25 2.25 0 1 1-4.5 0c0-.265.054-.514.138-.75H2a1.5 1.5 0 0 1-1.5-1.5V2.25A1.5 1.5 0 0 1 2 .75h12zm3 12.75a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 17 13.5zm-11.25 0a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 5.75 13.5zm11.228-9H14v9h1.334A2.24 2.24 0 0 1 17 12.75a2.24 2.24 0 0 1 1.666.75H20a.75.75 0 0 0 .75-.75V9.24l-3.161-4.426a.75.75 0 0 0-.61-.314zm-3.728-3H2a.75.75 0 0 0-.75.75v10.5c0 .415.336.75.75.75h2.083a2.24 2.24 0 0 1 1.667-.75 2.24 2.24 0 0 1 1.667.75h5.833v-12zm-7.5 9.75c.84 0 1.63.302 2.24.845a.376.376 0 0 1-.498.56A2.605 2.605 0 0 0 5.75 12c-.657 0-1.27.234-1.744.655a.375.375 0 1 1-.498-.56c.61-.543 1.4-.845 2.242-.845zm10.468-6c.49 0 .95.239 1.23.64l1.35 1.93A.75.75 0 0 1 18.184 9H14.75V5.25zm0 .75H15.5v2.25h2.684l-1.35-1.93a.75.75 0 0 0-.616-.32z" />
  </svg>
);

const StyledTruckIcon = styled(TruckIcon)`
  width: ${({ size = '1rem' }) => size};
  height: ${({ size = '1rem' }) => size};
  vertical-align: middle;
`;
export default StyledTruckIcon;
